export default __webpack_public_path__ + "static/media/eye.f244b8b8.svg";